$(document).ready(function () {
  setTimeout(function () {
    $('.load-delay').each(function () {
      $(this).attr('src', $(this).data('src'));
    });
  }, 2000);
});

$('.sidebar-menu').each(function () {
  let order = parseInt($(this).attr('data-sidebarmenu'));
  if (order != 1) {
    $(this).css('padding-left', `${order * 0.2 + 0.1}rem`);
  }
  if (
    $(this).next().attr('data-sidebarmenu') == $(this).attr('data-sidebarmenu')
  ) {
    $(this).find('.productgrid--sidebar-icon-wrapper').remove();
  }

  if (order >= 3) {
    $(this).addClass('sidebar-menu--border');
  }

  if ($(this).attr('data-sidebarmenu') != 0) {
    $(this).click(function () {
      let nextSibling = $(this).nextUntil(
        `[data-sidebarmenu='${order}'],
              [data-sidebarmenu='${order - 1}']`
      );
      nextSibling.toggleClass('accordion--active');
      $(this).toggleClass('productgrid--sidebar-button-active');
    });
  }
});

$('.sidebar-menu a').click(function (e) {
  e.stopPropagation();
});

// added by conversion bear - product page funnel support
$(document).on("click", ".product-form--atc-button", () => {
try {
    const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const variantIdFromQueryvalue = params.variant;
    
    console.log('show product page funnel')
const currenctVariantId = document
.querySelector(".product-form--atc-button")
.getAttribute("data-variant-id");
const currenctProductId = document
.querySelector(".product-form--atc-button")
.getAttribute("data-product-id");
if (currenctProductId && currenctVariantId && window.conversionBearUpsell) {
window.conversionBearUpsell.showFunnel("isProduct", {
originProductId: currenctProductId,
originVariantId: variantIdFromQueryvalue || currenctVariantId,
});
}
} catch (e) {
console.log(e);
}
});

// [SC] - 22nd Jan 2025 - sticky header improvement
document.addEventListener("DOMContentLoaded", function () {
    const screenWidth = window.innerWidth;
    const desktopNav = document.querySelector(".sc-desktop-nav-visible");
    const body = document.body;
    if (screenWidth <= 679) {
      if (desktopNav) {
          const navHeight = desktopNav.offsetHeight;
          body.style.paddingTop = `${navHeight}px`;
      }
    }
  
    const siteHeader = document.querySelector("header.site-header");
    window.addEventListener("scroll", function () {
      scrollTimeout = setTimeout(() => {
        if (window.scrollY > 150) {          
            siteHeader.classList.add("sc-mobile-stick-active");
        } else {
          siteHeader.classList.remove("sc-mobile-stick-active");
        }
      }, 500);
    });
});